"use client"; 

import { useState } from "react";

import SourceLogo from "../apps/sourceLogo"
import { classNames } from "@/lib/helpers"
import { appWebsiteLink, appPricingLink } from '@/lib/helpers'


export default function WFAPricingTable({ 
  sources, 
  pricingOptions,
  translations
}) {

  const [paymentType, setPaymentType] = useState('monthly') // true, false 


  const checkPriceMin = (price, pricingOptionId, pricingType) => {
    const pricingOption = pricingOptions?.find(x => x?.id === pricingOptionId)
    if (pricingType == 'monthly') {
      return pricingOption?.price_monthly_min === price ? true : false 
    } else {
      return pricingOption?.price_yearly_min === price ? true : false 
    }
  }


  return (
    <div className="border border-gray-200 rounded bg-gray-50 ">
          
      <div className="lg:flex w-full text-left py-3 px-6  ">
        
        <div className="lg:grow text-sm leading-6 text-gray-900 font-semibold py-2">
          {translations.header} 
        </div>

        <div className="lg:flex-none text-sm leading-6 text-gray-900 font-semibold">
          
          <span className="isolate inline-flex space-x-4">
            {[
              { id: 1, name: "monthly" },
              { id: 2, name: "yearly" }
            ]?.map(btn => (
              <button
                key={btn.id}
                type="button"
                className={classNames(paymentType === btn.name ? 
                  " text-crisp-600" : "text-gray-400", 
                  "inline-flex  py-2")}
                  // border-b-2 border-crisp-600
                onClick={() => setPaymentType(btn.name)}
                disabled={paymentType === btn.name}
              >            
                {translations.paymentTypes[btn.name]}
              </button>
            ))}

          </span>

        </div>        
      </div>
        <table className=" w-full whitespace-nowrap text-left">
          <colgroup>
            <col className="w-full " />
            <col className="lg:w-1/12" />
            <col className="lg:w-1/12" />
            <col className="lg:w-1/12" />
            <col className="lg:w-1/12" />
          </colgroup>

          <thead className="border-b border-t border-gray-200 text-sm leading-6 text-gray-900 ">
            <tr>
              <th scope="col" className="py-5 px-6 font-semibold ">
                {translations.platformsHeader}
              </th>

              {pricingOptions?.map((p, pIndex) => (
                <th 
                  key={pIndex}
                  scope="col" 
                  className={classNames(pIndex>=0 ? 
                    "hidden lg:table-cell" : "", 
                    "py-2 pl-0 pr-4 font-semibold sm:pr-8 text-left lg:pr-20")}
                >
                  {p.name}
                </th>
              ))}

            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {sources.map((source) => (
              <tr key={source.id}>
                
                <td className="py-3 px-4">
                  <div className="flex items-center gap-x-4">
                    
                    <a href={`/${source?.app?.slug}`} className="flex-none">
                      <SourceLogo source={source}  className='h-12 w-12 rounded-full bg-gray-50' />
                    </a>
                    
                    <div className="text-sm font-medium truncate">
                      <div className="truncate leading-6 text-gray-700">
                        <a href={`/${source?.app?.slug}`}>
                          {source?.app?.name}
                        </a>
                      </div>
                      <div className="truncate text-gray-500">                        
                        <a target="_blank"
                          className="hover:underline text-crisp-600 hover:text-crisp-800"
                          href={appPricingLink(source?.app) || `/${source?.app?.slug}`}
                        >
                          {source?.app?.name} {translations.pricingLink.pricingPart}{` →`}
                        </a>                        
                      </div>
                    </div>
                  </div>
                  
                  {/* Mobile only */}
                  <div className="space-y-1 mt-3 lg:mt-0">
                    {source?.priceData?.map((item, index) => (
                      <div key={index} className="lg:hidden flex space-x-3 text-sm text-gray-500">    
                        <div className="flex">
                          Volume: {pricingOptions[index].name}
                        </div>
                        <div className="w-full">
                          Plan: {item?.tier}
                        </div>                      
                        <div className="flex-none">
                          <p>
                            {paymentType === 'monthly' ? (
                              ![null, undefined].includes(item?.price_monthly) && 
                              <span className={checkPriceMin(item?.price_monthly, item?.pricing_option, 'monthly') ? 
                                'text-green-600 font-bold' : ''}
                              >                          
                                ${item?.price_monthly}
                              </span>                        
                            ) : (
                              ![null, undefined].includes(item?.price_yearly) &&
                              <span className={classNames(
                                checkPriceMin(item?.price_yearly, item?.pricing_option, 'yearly') ? 
                                'text-green-600 font-bold' : '', '')}
                              >
                                
                                ${paymentType === 'monthly' ? item?.price_monthly : item?.price_yearly}
                              </span>                        
                            )}

                          </p>                         
                        </div>

                      </div>
                    ))}
                  </div>
                  
                </td>

                {source?.priceData?.map((item, itemIndex) => (
                  <td key={itemIndex} className={classNames(itemIndex>=0 ? 
                    "hidden lg:table-cell" : "", 
                    "py-4 pl-0 pr-4 text-sm leading-6 sm:pr-8 lg:pr-16 text-gray-500")}
                  >
                    <p>
                      {paymentType === 'monthly' ? (
                        ![null, undefined].includes(item?.price_monthly) && 
                        <span className={checkPriceMin(item?.price_monthly, item?.pricing_option, 'monthly') ? 
                          'text-green-600 font-bold' : ''}
                        >                          
                          ${item?.price_monthly}
                        </span>                        
                      ) : (
                        ![null, undefined].includes(item?.price_yearly) &&
                        <span className={classNames(
                          checkPriceMin(item?.price_yearly, item?.pricing_option, 'yearly') ? 
                          'text-green-600 font-bold' : '', '')}
                        >
                          
                          ${paymentType === 'monthly' ? item?.price_monthly : item?.price_yearly}
                        </span>                        
                      )}

                    </p>
                    <p className="text-xs tracking-tighter">
                      {item?.tier}
                    </p>
                  </td>
                ))}

              </tr>
            ))}
          </tbody>
        </table>  
    </div>
  )
}